export default __webpack_public_path__ + "static/media/minecraft.5dbb9b84.jpeg";